/**
 * Appels des modèles de journée et du planning (§4.4, specs §6.1).
 *
 * Les quatre mutations de planning renvoient le planning complet : le cache est
 * remplacé d'un bloc, sans second aller-retour.
 */

import type {
  DayTemplateDTO,
  DayTemplateInput,
  PlanningResponse,
} from '../../../shared/types';
import { apiFetch } from './client';

function send<T>(method: string, path: string, body?: unknown): Promise<T> {
  return apiFetch<T>(path, {
    method,
    body: body === undefined ? undefined : JSON.stringify(body),
  });
}

export function fetchTemplates(): Promise<DayTemplateDTO[]> {
  return apiFetch<DayTemplateDTO[]>('/api/templates');
}

export function createTemplate(body: DayTemplateInput): Promise<DayTemplateDTO> {
  return send<DayTemplateDTO>('POST', '/api/templates', body);
}

/** Remplacement complet, repas types compris. Sans effet sur les journées créées. */
export function updateTemplate(id: number, body: DayTemplateInput): Promise<DayTemplateDTO> {
  return send<DayTemplateDTO>('PUT', `/api/templates/${String(id)}`, body);
}

export function deleteTemplate(id: number): Promise<void> {
  return send<void>('DELETE', `/api/templates/${String(id)}`);
}

export function fetchPlanning(): Promise<PlanningResponse> {
  return apiFetch<PlanningResponse>('/api/planning');
}

/** `weekday` : 0 = lundi … 6 = dimanche (§4.4). */
export function setWeekly(weekday: number, templateId: number): Promise<PlanningResponse> {
  return send<PlanningResponse>('PUT', `/api/planning/weekly/${String(weekday)}`, { templateId });
}

export function clearWeekly(weekday: number): Promise<PlanningResponse> {
  return send<PlanningResponse>('DELETE', `/api/planning/weekly/${String(weekday)}`);
}

/** Surcharge ponctuelle — **prime toujours** sur la récurrence (§4.4). */
export function setOverride(date: string, templateId: number): Promise<PlanningResponse> {
  return send<PlanningResponse>('PUT', `/api/planning/override/${date}`, { templateId });
}

export function clearOverride(date: string): Promise<PlanningResponse> {
  return send<PlanningResponse>('DELETE', `/api/planning/override/${date}`);
}
